import React from 'react';
import { motion } from 'framer-motion';
import './LogoScroll.css';

const MLB_LOGOS = [
  '108.svg',
  '110.svg',
  '111.svg',
  '112.svg',
  '113.svg',
  '114.svg',
  '115.svg',
  '116.svg',
  '117.svg',
  '118.svg',
  '119.svg',
  '120.svg',
  '121.svg',
  '133.svg',
  '134.svg',
  '135.svg',
  '136.svg',
  '137.svg',
  '138.svg',
  '139.svg',
  '140.svg',
  '141.svg',
  '142.svg',
  '143.svg',
  '144.svg',
  '145.svg',
  '146.svg',
  '147.svg',
  '158.svg',
  'Arizona Diamondbacks.svg'
];

const LogoScroll: React.FC = () => {
  // Double the logos for a seamless loop
  const displayLogos = [...MLB_LOGOS, ...MLB_LOGOS];

  return (
    <section className="logo-scroll-section">
      <div className="container">
        <motion.h2 
          className="logo-scroll-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          proudly serving the MLB
          <img src="/mlb.svg" alt="MLB" className="mlb-logo-title" />
        </motion.h2>
        <div className="logo-scroll-container">
          <div className="logo-scroll-track">
            {displayLogos.map((logo, index) => (
              <div key={`${logo}-${index}`} className="logo-scroll-item">
                <img src={`/MLB/${logo}`} alt="MLB Team Logo" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoScroll;
